import { TipiVisibilita } from "src/app/core/configuration/tipi-visibilita";
import { NotificaAttivitaResponse } from "src/app/core/models/notifica-attivita-response";
import { PrendiAttivitaCompletareResponse } from "src/app/core/models/prendi-attivita-completare-response";
import { ElaborationDocStatus } from "src/app/document-management/models/elaboration-doc-status";
import { SearchAdempimentiResponse } from "../../models/dto/search-adempimenti-response";
import { Provenienza } from "../../models/tipologiche/provenienza";
import { TipoDocumento } from "../../models/tipologiche/tipo-documento";
import { TipoTipologica } from "../../models/tipologiche/tipo-tipologica";
import { TipoVisibilita } from "../../models/tipologiche/tipo-visibilita";
import { FindConfigurationResponse } from "../models/dto/configuration-find";
import { Configuration } from "../models/configuration";
import { Injectable } from "@angular/core";
import { BehaviorSubject, Observable } from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class ConfigurationData {

  private tipiConfigurazioneBS$: BehaviorSubject<Configuration[]> = new BehaviorSubject<Configuration[]>([]);
  tipiConfigurazione$: Observable<Configuration[]> =this.tipiConfigurazioneBS$.asObservable();

  constructor() { }

  setTipiConfigurazione(configs: Configuration[]) {
    this.tipiConfigurazioneBS$.next(configs);
  }
  getTipiConfigurazione() {
  return this.tipiConfigurazioneBS$.value
 }
}
